module.exports = __webpack_public_path__ + "static/img/BEN-RIDGWAY.a1736d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BEN-RIDGWAY.jpg
// module id = bSFY
// module chunks = 0